import { createClient } from '@supabase/supabase-js'

// Check for environment variables and throw error if missing
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL or Anon Key is missing. Check your .env file.')
}

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Optional auth state listener for debugging
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', event, session)
})

export { supabase }
